// Le brief (14 octobre 2026) : l'entrée « Le weekly » devient « Le brief », lu
// à la semaine, à la quinzaine, au mois, au semestre et à l'année, chaque
// échelle avec ses éditions passées. Les cartes d'idées gardent leurs textes
// (`epureWeekly`, `projector.weekly`).
export default {
  echelles: 'Échelle du brief',
  terrain: 'Ce que le terrain dit',
  periodes: {
    hebdo: 'Semaine',
    bimensuel: 'Quinzaine',
    mensuel: 'Mois',
    semestriel: 'Semestre',
    annuel: 'Année',
  },
  edition: {
    hebdo: 'Semaine du {du} au {au}',
    bimensuel: 'Quinzaine du {du} au {au}',
    mensuel: '{mois}',
    semestre1: '1er semestre {an}',
    semestre2: '2e semestre {an}',
    annuel: '{an}',
    partielle: '{periode}, au {au}',
  },
  editionAria: 'Choisir une édition',
  lire: {
    hebdo: 'Lire la semaine',
    bimensuel: 'Lire la quinzaine',
    mensuel: 'Lire le mois en cours',
    semestriel: 'Lire le semestre en cours',
    annuel: 'Lire l’année en cours',
  },
  seLit: {
    hebdo: 'La semaine se lit.',
    bimensuel: 'La quinzaine se lit.',
    mensuel: 'Le mois se lit.',
    semestriel: 'Le semestre se lit.',
    annuel: 'L’année se lit.',
  },
  pasEncore: {
    hebdo: 'Pas encore de brief de la semaine.',
    bimensuel: 'Pas encore de brief de la quinzaine.',
    mensuel: 'Pas encore de brief du mois.',
    semestriel: 'Pas encore de brief du semestre.',
    annuel: 'Pas encore de brief de l’année.',
  },
  prochaine: {
    hebdo: 'Le brief de la semaine paraît de lui-même chaque semaine. « Lire la semaine » le lance tout de suite.',
    bimensuel: 'Le brief de la quinzaine paraît de lui-même toutes les deux semaines. « Lire la quinzaine » le lance tout de suite.',
    mensuel: 'Le brief du mois paraît de lui-même le {jour}, sur le mois écoulé. « Lire le mois en cours » le lit dès maintenant.',
    semestriel: 'Le brief du semestre paraît de lui-même le {jour}, sur le semestre écoulé. « Lire le semestre en cours » le lit dès maintenant.',
    annuel: 'Le brief de l’année paraît de lui-même le {jour}, sur l’année écoulée. « Lire l’année en cours » la lit dès maintenant.',
  },
  terrainDepuis: 'Le terrain couvre cette période à partir du {jour}.',
}
